import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Injectable({ providedIn: 'root' })
@Pipe({
    name: 'epRoleType',
    standalone: false
})
export class RoleTypePipe implements PipeTransform {
    transform(roleType: string) {
        let desc = '';
        if (!roleType) {
            return desc;
        }

        switch (roleType.toUpperCase()) {
            case 'BK':
                desc = 'Broker';
                break;
            case 'BO':
                desc = 'Book';
                break;
            case 'CL':
                desc = 'Claimant';
                break;
            case 'CN':
                desc = 'Consumer';
                break;
            case 'EM':
                desc = 'Employee';
                break;
            case 'FC':
                desc = 'Finance Company';
                break;
            case 'PR':
                desc = 'Provider';
                break;
            case 'SP':
                desc = 'Supplier';
                break;
            case 'TA':
                desc = 'Tax Authority';
                break;
            case 'TP':
                desc = 'Third Party';
                break;
        }

        return desc;
    }
}
